import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { AppSettingService } from '../../../../_services/_appSetting/app-setting.service';
import { SnackbarService } from '../../../../_services/snackbar/snackbar.service';

@Component({
    selector: 'lokos-snackbar',
    templateUrl: './snackbar.component.html',
    styleUrls: ['./snackbar.component.scss'],
    standalone: false,
})
export class SnackbarComponent implements OnDestroy {
    message: string;
    type: 'success' | 'error' | 'warning';
    showHelperBlock?: boolean;
    helperNumber?: string;
    helperHeading = '';
    theme!: string;
    subscriptions: Subscription[] = [];

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: any,
        private appSetting: AppSettingService,
        private snackbar: SnackbarService
    ) {
        this.message = data.message;
        this.type = data.type;
        this.showHelperBlock = data.showHelperBlock;
        this.helperNumber = data.helperNumber;
        this.helperHeading = data.helperHeading;

        const themeSub = this.appSetting.appTheme$.subscribe(
            (theme) => (this.theme = theme)
        );
        this.subscriptions.push(themeSub);
    }

    copyToClipboard() {
        if (this.helperNumber) {
            navigator.clipboard
                .writeText(this.helperNumber)
                .then(() => {
                    this.showHelperBlock = false;
                    this.snackbar.successSnackbar(
                        `${this.helperHeading} copied to clipboard`
                    );
                })
                .catch(() => {
                    this.snackbar.errorSnackbar(
                        'Could not copy Reference Number'
                    );
                });
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((sub: Subscription) => {
            sub.unsubscribe();
        });
    }
}
